import type { AppSettings, FileKind } from './types'

export const SUPPORTED_FORMATS: Array<{
  kind: FileKind
  label: string
  extensions: string[]
  description: string
}> = [
  {
    kind: 'docx',
    label: 'Word',
    extensions: ['.docx'],
    description: '连续阅读、基础文字轻编辑、DOCX/TXT 导出',
  },
  {
    kind: 'xlsx',
    label: 'Excel',
    extensions: ['.xlsx'],
    description: '表格/卡片模式、单元格轻编辑、XLSX/CSV 导出',
  },
  {
    kind: 'pdf',
    label: 'PDF',
    extensions: ['.pdf'],
    description: '浏览器内置阅读、缩放、页码与搜索',
  },
  {
    kind: 'md',
    label: 'Markdown',
    extensions: ['.md', '.markdown'],
    description: '默认渲染预览，可切源码编辑',
  },
  {
    kind: 'html',
    label: 'HTML',
    extensions: ['.html', '.htm'],
    description: '清理后放入 sandbox 预览，可切源码',
  },
  {
    kind: 'csv',
    label: 'CSV',
    extensions: ['.csv'],
    description: '表格与卡片模式、筛选结果导出',
  },
  {
    kind: 'json',
    label: 'JSON',
    extensions: ['.json'],
    description: '折叠树、格式化源码、结构校验',
  },
  {
    kind: 'lottie',
    label: 'Lottie',
    extensions: ['.lottie'],
    description: 'dotLottie 动画预览、源码查看与 JSON 导出',
  },
  {
    kind: 'txt',
    label: 'TXT',
    extensions: ['.txt', '.log'],
    description: '纯净阅读、全文编辑、TXT 导出',
  },
]

export const DEFAULT_SETTINGS: AppSettings = {
  theme: 'system',
  fontScale: 1,
  tableDensity: 'comfortable',
  loadRemoteImages: false,
}

export const FILE_LIMITS = {
  ordinaryBytes: 10 * 1024 * 1024,
  largeBytes: 30 * 1024 * 1024,
  maxTableRows: 5000,
  maxTableCols: 80,
  maxJsonTreeNodes: 3000,
}
